import { z } from 'zod';
import { PasswordSchema } from './password.js';
export const LoginRequest = z.object({
    email: z.string().email(),
    password: PasswordSchema,
}).strict();
export const LoginResponse = z.object({
    accessToken: z.string(),
}).strict();
